module.exports = __webpack_public_path__ + "img/icon-light-ecosystem-white.2a691e34.svg";